import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

// ANT DESIGN IMPORTS
import { Spin, Typography, Table, Collapse, Divider } from "antd";

//PROJECT IMPORTS
import { BOM } from "../../../../../../services/definedMethod";
import cnt from "../../../../../../services/definedConstant";
import { apiConfig } from "../../../../customer.config";
import NewLimit from "./NewLimit";
import DetailLimit from "./DetailLimit";
import EditLimit from "./EditLimit";

const { Text, Title } = Typography;
const { Panel } = Collapse;
const dateFormat = "YYYY-MM-DD";

const ManageLimit = (props) => {
  const { currentCustomerObj, userData } = props;
  const { session } = userData;

  const [limitLiabilityList, setLimitLiabilityList] = useState([]);
  const [originalList, setOriginalList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    BOM.HasPermission("READ_CLIENT_LIMIT") && getClientLimit();
  }, []);

  const columns = [
    {
      title: "Limit Line No",
      dataIndex: "limitLineNo",
      // sorter: (a, b) => a?.limitLineNo?.localeCompare(b?.limitLineNo),
    },
    {
      title: "Currency",
      dataIndex: "currency",
    },
    {
      title: "Account Limit",
      dataIndex: "accountLimit",
      render: (text) => <Text>{Number(text).toLocaleString()}</Text>,
    },
    {
      title: "Liability Category",
      dataIndex: "liabilityCategory",
    },

    {
      title: "Status",
      dataIndex: "status",
      render: (text) => (
        <Text strong style={{ color: text ? "green" : "red" }}>
          {text ? "Active" : "Inactive"}
        </Text>
      ),
    },
    {
      title: "Action",
      render: (_, record) => (
        <>
          {BOM.HasPermission("READ_CLIENT_LIMIT") && (
            <DetailLimit
              currentCustomerObj={currentCustomerObj}
              userData={userData}
              limitObj={record}
              refreshList={getClientLimit}
            />
          )}
          &nbsp;
          {BOM.HasPermission("UPDATE_CLIENT_LIMIT") && (
            <EditLimit
              currentCustomerObj={currentCustomerObj}
              userData={userData}
              limitObj={record}
              refreshList={getClientLimit}
            />
          )}
        </>
      ),
    },
  ];

  const getClientLimit = () => {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.ClientLimit}/${currentCustomerObj.id}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        setIsLoading(false);
        BOM.AlertMsg(cnt.DANGER, err.defaultUserMessage);
      } else {
        setIsLoading(false);

        const objList = res;
        let tempArray = [];

        objList.forEach((element) => {
          tempArray.push({
            key: element?.limitLineNumber,
            limitLineNo: element?.limitLineNumber ? element?.limitLineNumber : "-",
            status: element?.isActive,
            accountLimit: element?.accountLimit ? element?.accountLimit : "-",
            currency: element?.currency ? element?.currency.code : "-",
            liabilityCategory: element?.liabilityCategory ? element?.liabilityCategory : "-",
          });
        });

        //Display only active records list on the table; this will change after switching from authorized to disabled and vice versa.
        setLimitLiabilityList(tempArray);

        //keep the orginal data to use after gList is modified when change from autorise to disable
        setOriginalList(tempArray);

        //STOP LOAD
        setIsLoading(false);
      }
    });
  };

  return (
    <>
      <Spin spinning={isLoading} tip="Loading..." size="large">
        <NewLimit
          currentCustomerObj={currentCustomerObj}
          userData={userData}
          refreshList={getClientLimit}
        />
        <Divider style={{ marginTop: 10, marginBottom: 30 }} />

        <Table
          columns={columns}
          dataSource={limitLiabilityList}
          bordered
          pagination={{
            position: "bottomCentre",
            // pageSize: tableCount,
          }}
        />
      </Spin>
    </>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
});
export default connect(mapStateToProps, null)(ManageLimit);
